document.addEventListener('DOMContentLoaded', function () {
  const ALLOWED_HANDLES = [
    '30-days-growth-plan-30-sachets-cal-mag-zinc-drinks',
    'cal-mag-zincs-drinks-growth-plan'
  ];

  const block = document.querySelector('.joy-customer-referrals__block');
  if (!block) return;

  const pathname = window.location.pathname;
  const shouldShow = ALLOWED_HANDLES.some(handle =>
    pathname.includes(`/products/${handle}`)
  );

  if (!shouldShow) {
    block.style.display = 'none';
  }
});